module.exports = __webpack_public_path__ + "static/media/intro.8486eae3.mp3";